import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: "AIzaSyD71SPhYtVp-3Pow0m-CoevNVptoLxqRgs",
  authDomain: "uamc-60085.firebaseapp.com",
  projectId: "uamc-60085",
  storageBucket: "uamc-60085.appspot.com",
  messagingSenderId: "107325882183",
  appId: "1:107325882183:web:e2eb5beefb67328ff39662",
  measurementId: "G-L4RCT475RG"
};

const app = initializeApp(firebaseConfig)

export default app
